import { createContext, useContext } from 'react';
import { LangContextValue } from '../types/LangContextValue';

export const LangContext = createContext<LangContextValue>(undefined!);

export function useLangContext() {
  return useContext(LangContext);
}
